

export const Enlaces = Object.freeze({
    IG: 'https://www.instagram.com/inpur.poliuretano/',
    FB: 'https://www.facebook.com/InPur.AislacionesPoliuretano',
    WA: 'https://wa.me/+5492215349179'
});